<template>

  <div class="hflex">
    <div
      class="hflex-col-0 hflex-options"
      style="min-width: 200px">
      <div class="list-group list-group-flush">
        <router-link
          :class="{ active: tab === 'match' }"
          :to="mainRoute"
          class="list-group-item list-group-item-action"><b>{{ total_match.length }}</b> Match</router-link>
        <router-link
          :to="mainRoute + '/invited'"
          :class="{ active: tab === 'invited' }"
          class="list-group-item list-group-item-action"><b>{{ total_invited.length }}</b> Abordados</router-link>
        <router-link
          :to="mainRoute + '/applied'"
          :class="{ active: tab === 'applied' }"
          class="list-group-item list-group-item-action"><b>{{ total_applied.length }}</b> Interessados</router-link>
        <div style="height: 10px; background: rgba(0,0,0,0.1)"></div>
        <router-link
          :to="mainRoute + '/considered'"
          :class="{ active: ['considered', 'disregarded'].includes(tab) }"
          class="list-group-item list-group-item-action"><b>{{ total_considered.length }}</b> Pré-selecionados</router-link>
        <div style="height: 10px; background: rgba(0,0,0,0.1)"></div>
        <router-link
          :to="mainRoute + '/config'"
          :class="{ active: tab === 'config' }"
          class="list-group-item list-group-item-action">Configurações</router-link>
      </div>
    </div>
    <div
      v-if="tab === 'config'"
      class="hflex-col-1">
      <div class="p-3">
        <div style="max-width: 600px">
          <RhevolutJobConfig
            @save="$router.push('/rhevolut/jobs/match')" />
        </div>
      </div>
    </div>
    <div
      v-if="tab !== 'config'"
      class="hflex-col-1">
      <div class="vflex">
        <div
          v-if="['considered', 'disregarded'].includes(tab)"
          class="vflex-row-0 vflex-header p-3"
          style="text-align: right;">
          <div class="btn-group" role="group" aria-label="Basic example">
            <router-link
              :to="mainRoute + '/considered'"
              class="btn"
              :class="tab === 'considered' ? 'btn-secondary' : 'btn-light'"><i class="fa-solid fa-thumbs-up"></i> {{ total_considered.length }} Avaliando</router-link>
            <router-link
              :to="mainRoute + '/disregarded'"
              class="btn"
              :class="tab === 'disregarded' ? 'btn-secondary' : 'btn-light'"><i class="fa-solid fa-thumbs-down"></i> {{ total_disregarded.length }} Eliminados</router-link>
          </div>
        </div>
        <div class="vflex-row-1">
          <Paginaty
            :total="total"
            :pages="pages"
            :page="page"
            :creating="creating"
            :loading="loading"
            @changePage="loadData">

            <template slot="content">
              <div
                class="list-group list-group-flush">
                <RhevolutJobItem
                  v-for="(candidate, i) in candidatesFiltered"
                  :key="`candidate-${i}`"
                  :class="{ 'list-group-item-secondary': candidate.candidate_id === candidateId }"
                  :candidate="candidate"
                  :tab="tab"
                  @select="setCandidate"
                  @changeStatus="changeStatus" />
              </div>
            </template>

            <template slot="noresults">
              {{ $t('There are no items') }}
            </template>

          </Paginaty>
        </div>
      </div>

    </div>
    <div
      v-if="tab !== 'config'"
      class="hflex-col-1 profile">
      <div class="p-4">
        <RhevolutJobProfile
          v-if="candidate"
          :candidate="candidate"
          :tab="tab"
          @changeStatus="changeStatus" />
      </div>
    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import RhevolutJobConfig from './RhevolutJobConfig'
import RhevolutJobForm from './RhevolutJobForm'
import RhevolutJobItem from './RhevolutJobItem'
import RhevolutJobProfile from './RhevolutJobProfile'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'RhevolutJob',
  components: {
    ThSort,
    RhevolutJobConfig,
    RhevolutJobForm,
    RhevolutJobItem,
    RhevolutJobProfile,
    Paginaty
  },
  props: [
  ],
  data () {
    return {
      status: 'qualified',
      candidateId: null,
      modeEdit: false,
      candidates: [{
        'invited': false,
        'applied': false,
        'accessible': false,
        'disregarded': false,
        'candidate_id': 1,
        'percentage': 92,
        'name': 'João Silva',
        'phone': '+55 11 99558-7458',
        'email': 'joao.silva@example.com',
        'important_values': ['Confiança', 'Transparência', 'Diversidade'],
        'desired_areas': ['Tecnologia', 'Oportunidade de Crescimento'],
        'subareas_or_technologies': ['Javascript', 'Node.js'],
        'work_preferences': ['Remoto', 'Híbrido'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Grandes Empresas'],
        'preferred_sectors': ['Tecnologia', 'Educação', 'Saúde'],
        'unwanted_sectors': ['Financeiro'],
        'contract_type': {'CLT': 'R$ 12.000,00', 'PJ': 'R$ 15.000,00'},
        'main_benefits': ['Plano de Saúde', 'Flexibilidade de Horário'],
        'unacceptable_conditions': ['Ambiente tóxico', 'Falta de transparência'],
        'personal_values': ['Honestidade', 'Dedicação', 'Colaboração', 'Inovação', 'Responsabilidade'],
        'behavioral_style': ['Proativo'],
        'skills': {
          'Javascript': 3,
          'Node.js': 3,
          'React': 2,
          'TypeScript': 1
        }
      }, {
        'invited': false,
        'applied': true,
        'accessible': true,
        'disregarded': false,
        'candidate_id': 2,
        'percentage': 89,
        'name': 'Maria Fernandes',
        'phone': '+55 21 98765-4321',
        'email': 'maria.fernandes@example.com',
        'important_values': ['Respeito', 'Inovação', 'Trabalho em equipe'],
        'desired_areas': ['Marketing', 'Design'],
        'subareas_or_technologies': ['SEO', 'UI/UX Design'],
        'work_preferences': ['Presencial', 'Híbrido'],
        'work_location': ['São Paulo', 'Rio de Janeiro'],
        'languages': ['Português', 'Espanhol'],
        'preferred_company_type': ['Agências', 'Startups'],
        'preferred_sectors': ['Publicidade', 'Tecnologia', 'Entretenimento'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 9.000,00', 'PJ': 'R$ 12.000,00'},
        'main_benefits': ['Vale Refeição', 'Desenvolvimento Profissional'],
        'unacceptable_conditions': ['Jornada exaustiva', 'Falta de reconhecimento'],
        'personal_values': ['Criatividade', 'Comprometimento', 'Transparência', 'Empatia', 'Adaptabilidade'],
        'behavioral_style': ['Colaborativo'],
        'skills': {
          'Bootstrap': 3,
          'Vue.js': 3,
          'TypeScript': 2,
          'Angular': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 3,
        'percentage': 83,
        'name': 'Carlos Souza',
        'phone': '+55 31 45612-3789',
        'email': 'carlos.souza@example.com',
        'important_values': ['Inovação', 'Sustentabilidade', 'Diversidade'],
        'desired_areas': ['Pesquisa e Desenvolvimento', 'Engenharia'],
        'subareas_or_technologies': ['Energia Renovável', 'Automação'],
        'work_preferences': ['Remoto'],
        'work_location': ['São Paulo', 'Guarulhos'],
        'languages': ['Português', 'Inglês', 'Francês'],
        'preferred_company_type': ['Empresas de Tecnologia', 'Empresas Sustentáveis'],
        'preferred_sectors': ['Tecnologia', 'Energia', 'Sustentabilidade'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 14.000,00', 'PJ': 'R$ 18.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Desigualdade', 'Falta de ética'],
        'personal_values': ['Sustentabilidade', 'Inovação', 'Ética', 'Diversidade', 'Empreendedorismo'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'Python': 3,
          'Java': 3,
          'C#': 2,
          'C++': 2,
          'Ruby': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 4,
        'percentage': 80,
        'name': 'Ana Costa',
        'phone': '+55 11 32165-4987',
        'email': 'ana.costa@example.com',
        'important_values': ['Ética', 'Inovação', 'Transparência'],
        'desired_areas': ['TI', 'Gestão de Projetos'],
        'subareas_or_technologies': ['Big Data', 'DevOps'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['Campinas', 'São Paulo'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Multinacionais', 'Startups'],
        'preferred_sectors': ['Tecnologia', 'Consultoria', 'Educação'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 11.000,00', 'PJ': 'R$ 14.000,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência', 'Respeito'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Elixir': 3,
          'React': 3,
          'TypeScript': 2,
          'Node.js': 2
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 5,
        'percentage': 78,
        'name': 'Pedro Lima',
        'phone': '+55 21 78912-3456',
        'email': 'pedro.lima@example.com',
        'important_values': ['Respeito', 'Empatia', 'Transparência'],
        'desired_areas': ['Recursos Humanos', 'Administração'],
        'subareas_or_technologies': ['Gestão de Pessoas', 'Recrutamento'],
        'work_preferences': ['Presencial', 'Híbrido'],
        'work_location': ['São Paulo', 'Rio de Janeiro'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Empresas Familiares'],
        'preferred_sectors': ['Serviços', 'Tecnologia', 'Educação'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 8.000,00', 'PJ': 'R$ 10.000,00'},
        'main_benefits': ['Vale Refeição', 'Plano de Saúde'],
        'unacceptable_conditions': ['Falta de Respeito', 'Assédio Moral'],
        'personal_values': ['Empatia', 'Respeito', 'Comprometimento', 'Ética', 'Colaboração'],
        'behavioral_style': 'Empático',
        'skills': {
          'Bootstrap': 3,
          'Vue.js': 3,
          'C#': 2,
          'Python': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 6,
        'percentage': 76,
        'name': 'Fernanda Almeida',
        'phone': '+55 61 65478-9321',
        'email': 'fernanda.almeida@example.com',
        'important_values': ['Inovação', 'Sustentabilidade', 'Ética'],
        'desired_areas': ['Engenharia', 'Tecnologia'],
        'subareas_or_technologies': ['Automação', 'Robótica'],
        'work_preferences': ['Remoto'],
        'work_location': ['São Paulo', 'Jundiaí'],
        'languages': ['Português', 'Inglês', 'Alemão'],
        'preferred_company_type': ['Empresas de Tecnologia', 'Empresas Sustentáveis'],
        'preferred_sectors': ['Tecnologia', 'Indústria', 'Sustentabilidade'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 13.000,00', 'PJ': 'R$ 16.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Falta de Ética', 'Desigualdade'],
        'personal_values': ['Inovação', 'Sustentabilidade', 'Ética', 'Respeito', 'Colaboração'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'Flutter': 3,
          'Java': 3,
          'Node.js': 2,
          'Python': 1
        }
      }, {
        'invited': false,
        'applied': true,
        'disregarded': false,
        'candidate_id': 7,
        'percentage': 70,
        'name': 'Ricardo Pereira',
        'phone': '+55 11 98732-1654',
        'email': 'ricardo.pereira@example.com',
        'important_values': ['Respeito', 'Transparência', 'Inovação'],
        'desired_areas': ['Marketing', 'Comunicação'],
        'subareas_or_technologies': ['SEO', 'Content Marketing'],
        'work_preferences': ['Híbrido', 'Remoto'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês', 'Espanhol'],
        'preferred_company_type': ['Agências', 'Startups'],
        'preferred_sectors': ['Publicidade', 'Tecnologia', 'Entretenimento'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 7.500,00', 'PJ': 'R$ 9.000,00'},
        'main_benefits': ['Vale Refeição', 'Desenvolvimento Profissional'],
        'unacceptable_conditions': ['Jornada Exaustiva', 'Falta de Reconhecimento'],
        'personal_values': ['Criatividade', 'Transparência', 'Comprometimento', 'Inovação', 'Respeito'],
        'behavioral_style': 'Colaborativo',
        'skills': {
          'Angular': 3,
          'Bootstrap': 2,
          'React': 1,
          'TypeScript': 2
        }
      }, {
        'invited': false,
        'applied': true,
        'disregarded': false,
        'candidate_id': 8,
        'percentage': 70,
        'name': 'Sofia Rocha',
        'phone': '+55 71 32178-9456',
        'email': 'sofia.rocha@example.com',
        'important_values': ['Ética', 'Inovação', 'Transparência'],
        'desired_areas': ['TI', 'Segurança da Informação'],
        'subareas_or_technologies': ['Cybersecurity', 'Cloud Computing'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['Campinas', 'São Paulo'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Multinacionais', 'Startups'],
        'preferred_sectors': ['Tecnologia', 'Consultoria', 'Educação'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 10.000,00', 'PJ': 'R$ 12.000,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência', 'Respeito'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Angular': 3,
          'Elixir': 2,
          'Java': 2,
          'Node.js': 1
        }
      }, {
        'invited': false,
        'applied': true,
        'disregarded': false,
        'candidate_id': 9,
        'percentage': 70,
        'name': 'Lucas Martins',
        'phone': '+55 61 65432-1789',
        'email': 'lucas.martins@example.com',
        'important_values': ['Empatia', 'Transparência', 'Inovação'],
        'desired_areas': ['Desenvolvimento de Produto', 'Gestão de Projetos'],
        'subareas_or_technologies': ['Scrum', 'Agile'],
        'work_preferences': ['Remoto', 'Híbrido'],
        'work_location': ['São Paulo', 'Guarulhos'],
        'languages': ['Português', 'Inglês', 'Francês'],
        'preferred_company_type': ['Startups', 'Empresas de Tecnologia'],
        'preferred_sectors': ['Tecnologia', 'Educação', 'Saúde'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 12.000,00', 'PJ': 'R$ 15.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Desigualdade', 'Falta de Ética'],
        'personal_values': ['Sustentabilidade', 'Inovação', 'Ética', 'Diversidade', 'Empreendedorismo'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'React': 3,
          'TypeScript': 3,
          'Node.js': 2,
          'Python': 1
        }
      }, {
        'invited': false,
        'applied': true,
        'accessible': true,
        'disregarded': false,
        'candidate_id': 10,
        'percentage': 70,
        'name': 'Mariana Oliveira',
        'phone': '+55 11 78965-4123',
        'email': 'mariana.oliveira@example.com',
        'important_values': ['Ética', 'Transparência', 'Inovação'],
        'desired_areas': ['TI', 'Desenvolvimento de Software'],
        'subareas_or_technologies': ['Desenvolvimento Web', 'Inteligência Artificial'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Grandes Empresas'],
        'preferred_sectors': ['Tecnologia', 'Educação', 'Saúde'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 11.000,00', 'PJ': 'R$ 13.000,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência', 'Respeito'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Angular': 3,
          'React': 3,
          'Node.js': 2,
          'Python': 2
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 11,
        'percentage': 75,
        'name': 'Aline Pereira',
        'phone': '+55 11 99876-5432',
        'email': 'aline.pereira@example.com',
        'important_values': ['Inovação', 'Ética', 'Transparência'],
        'desired_areas': ['Desenvolvimento de Software', 'TI'],
        'subareas_or_technologies': ['Java', 'React'],
        'work_preferences': ['Remoto'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Grandes Empresas'],
        'preferred_sectors': ['Tecnologia', 'Educação'],
        'unwanted_sectors': ['Financeiro'],
        'contract_type': {'CLT': 'R$ 10.000,00', 'PJ': 'R$ 12.500,00'},
        'main_benefits': ['Plano de Saúde', 'Home Office'],
        'unacceptable_conditions': ['Ambiente tóxico', 'Falta de transparência'],
        'personal_values': ['Honestidade', 'Dedicação', 'Colaboração', 'Inovação'],
        'behavioral_style': ['Proativo'],
        'skills': {
          'Java': 3,
          'React': 3,
          'Node.js': 2,
          'Angular': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 12,
        'percentage': 72,
        'name': 'Bruno Castro',
        'phone': '+55 21 99876-1234',
        'email': 'bruno.castro@example.com',
        'important_values': ['Respeito', 'Inovação', 'Trabalho em equipe'],
        'desired_areas': ['Marketing', 'Publicidade'],
        'subareas_or_technologies': ['SEO', 'Content Marketing'],
        'work_preferences': ['Híbrido'],
        'work_location': ['Rio de Janeiro', 'São Paulo'],
        'languages': ['Português', 'Espanhol'],
        'preferred_company_type': ['Agências', 'Startups'],
        'preferred_sectors': ['Publicidade', 'Tecnologia'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 8.000,00', 'PJ': 'R$ 10.000,00'},
        'main_benefits': ['Vale Refeição', 'Desenvolvimento Profissional'],
        'unacceptable_conditions': ['Jornada exaustiva', 'Falta de reconhecimento'],
        'personal_values': ['Criatividade', 'Comprometimento', 'Transparência', 'Empatia'],
        'behavioral_style': ['Colaborativo'],
        'skills': {
          'SEO': 3,
          'Content Marketing': 3,
          'UI/UX Design': 2,
          'Angular': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 13,
        'percentage': 70,
        'name': 'Carla Nogueira',
        'phone': '+55 31 98765-4321',
        'email': 'carla.nogueira@example.com',
        'important_values': ['Inovação', 'Sustentabilidade', 'Diversidade'],
        'desired_areas': ['Pesquisa e Desenvolvimento', 'Engenharia'],
        'subareas_or_technologies': ['Automação', 'Energia Renovável'],
        'work_preferences': ['Remoto'],
        'work_location': ['São Paulo', 'Curitiba'],
        'languages': ['Português', 'Inglês', 'Francês'],
        'preferred_company_type': ['Empresas de Tecnologia', 'Empresas Sustentáveis'],
        'preferred_sectors': ['Tecnologia', 'Energia'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 13.000,00', 'PJ': 'R$ 16.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Desigualdade', 'Falta de ética'],
        'personal_values': ['Sustentabilidade', 'Inovação', 'Ética', 'Diversidade'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'Python': 3,
          'Java': 3,
          'C#': 2,
          'C++': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 14,
        'percentage': 64,
        'name': 'Daniel Silva',
        'phone': '+55 11 99876-5432',
        'email': 'daniel.silva@example.com',
        'important_values': ['Ética', 'Inovação', 'Transparência'],
        'desired_areas': ['TI', 'Gestão de Projetos'],
        'subareas_or_technologies': ['Big Data', 'DevOps'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['São Paulo', 'Porto Alegre'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Multinacionais', 'Startups'],
        'preferred_sectors': ['Tecnologia', 'Consultoria'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 11.000,00', 'PJ': 'R$ 13.000,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Elixir': 3,
          'React': 2,
          'Node.js': 2,
          'TypeScript': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 15,
        'percentage': 63,
        'name': 'Elisa Gomes',
        'phone': '+55 21 98765-1234',
        'email': 'elisa.gomes@example.com',
        'important_values': ['Respeito', 'Empatia', 'Transparência'],
        'desired_areas': ['Recursos Humanos', 'Administração'],
        'subareas_or_technologies': ['Gestão de Pessoas', 'Recrutamento'],
        'work_preferences': ['Presencial', 'Híbrido'],
        'work_location': ['Rio de Janeiro', 'Niterói'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Empresas Familiares'],
        'preferred_sectors': ['Serviços', 'Educação'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 8.000,00', 'PJ': 'R$ 9.500,00'},
        'main_benefits': ['Vale Refeição', 'Plano de Saúde'],
        'unacceptable_conditions': ['Falta de Respeito', 'Assédio Moral'],
        'personal_values': ['Empatia', 'Respeito', 'Comprometimento', 'Ética'],
        'behavioral_style': ['Empático'],
        'skills': {
          'Bootstrap': 3,
          'Vue.js': 3,
          'C#': 2,
          'Python': 2
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 16,
        'percentage': 62,
        'name': 'Fernando Albuquerque',
        'phone': '+55 61 98765-4321',
        'email': 'fernando.albuquerque@example.com',
        'important_values': ['Inovação', 'Sustentabilidade', 'Ética'],
        'desired_areas': ['Engenharia', 'Tecnologia'],
        'subareas_or_technologies': ['Robótica', 'Automação'],
        'work_preferences': ['Remoto'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês', 'Alemão'],
        'preferred_company_type': ['Empresas de Tecnologia', 'Empresas Sustentáveis'],
        'preferred_sectors': ['Tecnologia', 'Indústria'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 13.000,00', 'PJ': 'R$ 15.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Falta de Ética', 'Desigualdade'],
        'personal_values': ['Inovação', 'Sustentabilidade', 'Ética', 'Respeito'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'Flutter': 2,
          'Java': 3,
          'Node.js': 3,
          'Python': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 17,
        'percentage': 60,
        'name': 'Gabriela Souza',
        'phone': '+55 11 99876-5432',
        'email': 'gabriela.souza@example.com',
        'important_values': ['Respeito', 'Transparência', 'Inovação'],
        'desired_areas': ['Marketing', 'Comunicação'],
        'subareas_or_technologies': ['SEO', 'Content Marketing'],
        'work_preferences': ['Híbrido', 'Remoto'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês', 'Espanhol'],
        'preferred_company_type': ['Agências', 'Startups'],
        'preferred_sectors': ['Publicidade', 'Tecnologia'],
        'unwanted_sectors': ['Indústria'],
        'contract_type': {'CLT': 'R$ 7.500,00', 'PJ': 'R$ 9.000,00'},
        'main_benefits': ['Vale Refeição', 'Desenvolvimento Profissional'],
        'unacceptable_conditions': ['Jornada Exaustiva', 'Falta de Reconhecimento'],
        'personal_values': ['Criatividade', 'Transparência', 'Comprometimento', 'Inovação'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Angular': 3,
          'Bootstrap': 3,
          'React': 1,
          'TypeScript': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 18,
        'percentage': 58,
        'name': 'Henrique Rodrigues',
        'phone': '+55 71 98765-4321',
        'email': 'henrique.rodrigues@example.com',
        'important_values': ['Ética', 'Inovação', 'Transparência'],
        'desired_areas': ['TI', 'Segurança da Informação'],
        'subareas_or_technologies': ['Cybersecurity', 'Cloud Computing'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['Salvador', 'São Paulo'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Multinacionais', 'Startups'],
        'preferred_sectors': ['Tecnologia', 'Consultoria'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 10.000,00', 'PJ': 'R$ 12.000,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Angular': 3,
          'Elixir': 2,
          'Java': 1,
          'Node.js': 1
        }
      }, {
        'invited': false,
        'applied': false,
        'disregarded': false,
        'candidate_id': 19,
        'percentage': 57,
        'name': 'Isabel Ferreira',
        'phone': '+55 61 98765-4321',
        'email': 'isabel.ferreira@example.com',
        'important_values': ['Empatia', 'Transparência', 'Inovação'],
        'desired_areas': ['Desenvolvimento de Produto', 'Gestão de Projetos'],
        'subareas_or_technologies': ['Scrum', 'Agile'],
        'work_preferences': ['Remoto', 'Híbrido'],
        'work_location': ['Brasília', 'São Paulo'],
        'languages': ['Português', 'Inglês', 'Francês'],
        'preferred_company_type': ['Startups', 'Empresas de Tecnologia'],
        'preferred_sectors': ['Tecnologia', 'Educação'],
        'unwanted_sectors': ['Financeiro', 'Tabaco'],
        'contract_type': {'CLT': 'R$ 12.000,00', 'PJ': 'R$ 14.000,00'},
        'main_benefits': ['Home Office', 'Plano de Carreira'],
        'unacceptable_conditions': ['Desigualdade', 'Falta de Ética'],
        'personal_values': ['Sustentabilidade', 'Inovação', 'Ética', 'Diversidade'],
        'behavioral_style': ['Inovador'],
        'skills': {
          'React': 3,
          'TypeScript': 3,
          'Node.js': 2,
          'Python': 1
        }
      }, {
        'invited': false,
        'applied': true,
        'accessible': true,
        'disregarded': false,
        'candidate_id': 20,
        'percentage': 70,
        'name': 'Júlia Mendes',
        'phone': '+55 11 98765-4321',
        'email': 'julia.mendes@example.com',
        'important_values': ['Ética', 'Transparência', 'Inovação'],
        'desired_areas': ['TI', 'Desenvolvimento de Software'],
        'subareas_or_technologies': ['Inteligência Artificial', 'Desenvolvimento Web'],
        'work_preferences': ['Remoto', 'Presencial'],
        'work_location': ['São Paulo', 'Campinas'],
        'languages': ['Português', 'Inglês'],
        'preferred_company_type': ['Startups', 'Grandes Empresas'],
        'preferred_sectors': ['Tecnologia', 'Educação'],
        'unwanted_sectors': ['Agronegócio'],
        'contract_type': {'CLT': 'R$ 11.000,00', 'PJ': 'R$ 13.500,00'},
        'main_benefits': ['Plano de Saúde', 'Auxílio Educação'],
        'unacceptable_conditions': ['Ambiente Tóxico', 'Falta de Oportunidades'],
        'personal_values': ['Integridade', 'Inovação', 'Colaboração', 'Transparência'],
        'behavioral_style': ['Liderança'],
        'skills': {
          'Angular': 3,
          'React': 3,
          'Node.js': 2,
          'Python': 2
        }
      }],
      total: 10,
      pages: 5,
      page: 1,
      creating: false,
      loading: false,
      filters: {},
      sort: '-created_at'
    }
  },
  computed: {
    mainRoute () {
      if (this.$route.path.includes('/job/')) {
        return `/job/${this.$route.params.id}/rhevolut`
      } else {
        return `/rhevolut/jobs/123`
      }
    },
    tab () {
      const tab = this.$route.params.tab
      return tab || 'match'
    },
    subtab () {
      const subtab = this.$route.params.subtab
      return subtab || 'qualified'
    },
    job () {
      return this.$store.getters.getJob
    },
    candidatesFiltered () {
      if (this.tab === 'invited') {
        return this.total_invited
      }
      if (this.tab === 'applied') {
        return this.total_applied
      }
      if (this.tab === 'considered') {
        return this.total_considered
      }
      if (this.tab === 'disregarded') {
        return this.total_disregarded
      }
      if (this.tab === 'match') {
        return this.total_match
      }
    },
    total_invited () {
      return this.candidates.filter(item => {
        return item.invited && !item.accessible
      })
    },
    total_applied () {
      return this.candidates.filter(item => {
        return item.applied && !item.accessible
      })
    },
    total_considered () {
      return this.candidates.filter(item => {
        return item.accessible && !item.disregarded
      })
    },
    total_disregarded () {
      return this.candidates.filter(item => {
        return item.accessible && item.disregarded
      })
    },
    total_match () {
      return this.candidates.filter(item => {
        return !item.accessible && !item.invited && !item.applied
      })
    },
    candidate () {
      return this.candidates.find(item => {
        return item.candidate_id === this.candidateId
      })
    }
  },
  watch: {
    tab () {
      this.setCandidate(null)
    }
  },
  created () {
  },
  methods: {
    loadData () {},
    changeTab (tab) {
      this.tab = tab
      this.candidateIndex = 0
    },
    changeStatus (params) {
      const {
        status,
        id
      } = params

      const candidate = this.candidates.find(item => item.candidate_id === id)
      if (candidate) {
        if (status === 'contact') {
          return this.$store.dispatch('setAlertModal', {
            title: 'Exibir dados de contato.',
            message: `
            Esse candidato se interessou pela vaga. Isso é ótimo! Você pode clicar em "Ok" para acessar os dados completos do candidato.
            <br><br>
            Essa ação consumirá 1 crédito.
            `,
            type: 'ok',
            style: 'primary',
            action: () => {
              this.$set(candidate, 'accessible', true)
              // candidate.status = status
            }
          })
        }
        if (status === 'invited') {
          return this.$store.dispatch('setAlertModal', {
            title: 'Abordar candidato.',
            message: `
            Ao abordar este candidato, uma mensagem com os detalhes da vaga será enviada por e-mail e WhatsApp. Se o candidato aceitar o convite, você terá acesso completo aos dados de contato dele.<br><br>
            Essa ação consumirá 1 crédito.
            `.trim(),
            type: 'ok',
            style: 'primary',
            action: () => {
              candidate.invited = true
              // candidate.status = status
            }
          })
        }
        candidate.status = status
      }
    },
    setCandidate (id) {
      if (id) {
        this.candidateId = id
      } else {
        this.candidateId = this.candidatesFiltered[0] ? this.candidatesFiltered[0].candidate_id : null
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.skills {
  display: flex;
  flex-wrap: wrap;
}
.skills > * {
  margin: 0.1em;
  padding: 0.3em 0.8em;
  border-radius: 2em;
}

.profile {
  background: rgba(0,0,0,0.1);
}

.options {
  display: flex;
  flex-wrap: wrap;
}
  .options * {
    padding: 0.4em 0.8em;
    margin: 0.2em;
  }
.btn-options {
  padding: 0.5em;
  display: flex;
}
  .btn-options > span {
    display: block;
    padding: 0.4em;
    flex: 1;
    text-align: left;
  }
  .btn-options > select {
    display: block;
    flex: 1;
  }
.btn-option-binary {
  display: flex;
}
  .btn-option-binary > * {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJob/RhevolutJob.vue